import { render, staticRenderFns } from "./MedicineOrders.html?vue&type=template&id=218b934b&scoped=true&external"
import script from "./MedicineOrders.js?vue&type=script&lang=js&external"
export * from "./MedicineOrders.js?vue&type=script&lang=js&external"
import style0 from "./MedicineOrders.vue?vue&type=style&index=0&id=218b934b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b934b",
  null
  
)

export default component.exports